import React, {useEffect, useState} from 'react';

import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import InputComponentV2 from '../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
import SeparatorComponent from '../common/genericComponents/separatorComponent/separatorComponent';

import './mentorNotes.css';

const MentorNotes = ({
  isTeamChatRoom,
  notesValue,
  handleChange = () => {},
  handleClose = () => {},
  onSaveNote = () => {},
}) => {
  const [isSaveBtnClicked, setIsSaveBtnClicked] = useState(false);
  const [showShakeAnim, setShowShakeAnim] = useState(false);
  const [isNotesValid, setIsNotesValid] = useState(true);

  useEffect(() => {
    if (notesValue?.trim()?.length === 0) {
      setIsNotesValid(false);
    } else setIsNotesValid(true);
  }, [notesValue]);

  const onSave = () => {
    setIsSaveBtnClicked(true);
    if (!notesValue || notesValue.trim().length === 0) {
      setShowShakeAnim(true);
      setIsNotesValid(false);
    } else {
      onSaveNote();
    }
  };

  return (
    <div className="et-mentor-notes-container">
      <FormComponentV2
        isRightBtnDisabled={
          isSaveBtnClicked && (!notesValue || notesValue.trim().length === 0)
        }
        showShakeAnim={showShakeAnim}
        formTitle={(isTeamChatRoom ? 'Team' : 'Personal') + ' note'}
        leftBtnTxt="Close"
        rightBtnTxt="Save note"
        onLeftBtnClicked={handleClose}
        onRightBtnClicked={onSave}>
        <SeparatorComponent />
        <InputComponentV2
          id="mentor_notes"
          noWaitOnInput={true}
          defaultValue={notesValue || ''}
          errorMessage="Please provide some value"
          inputType="textarea"
          placeholder={`Write ${isTeamChatRoom ? 'team' : 'private'} note…`}
          titleTxt="Keep track of important information from your interactions"
          onChange={handleChange}
          showCustomError={isSaveBtnClicked && !isNotesValid}
          hideCharacterCount={true}
        />
        <SeparatorComponent />
      </FormComponentV2>
    </div>
  );
};

export default MentorNotes;
